import { createSlice } from '@reduxjs/toolkit';
import { Resource } from 'model/Resource';

import { fetchPulseSurveyTemplateLibrary } from './asyncActions';
import { PulseSurveyTemplateLibraryState, STORE_NAME } from './initialState';

export const pulseSurveyTemplateLibrarySlice = createSlice({
  name: STORE_NAME,
  initialState: PulseSurveyTemplateLibraryState.INITIAL_DOMAIN,
  reducers: {
    clearPulseSurveyTemplateLibrary: () => PulseSurveyTemplateLibraryState.INITIAL_DOMAIN,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPulseSurveyTemplateLibrary.pending, (state) => {
        state.listResource = Resource.createPendingResource();
      })
      .addCase(fetchPulseSurveyTemplateLibrary.fulfilled, (state, action) => {
        state.listResource = Resource.createResolvedResource({ data: action.payload.list });
        state.listPagination = action.payload.pagination;
      })
      .addCase(fetchPulseSurveyTemplateLibrary.rejected, (state, action) => {
        state.listResource = Resource.createRejectedResource({ error: action.error });
        state.listPagination = null;
      });
  },
});

export const { clearPulseSurveyTemplateLibrary } = pulseSurveyTemplateLibrarySlice.actions;
